import React from "react";
import { useForm, FormProvider } from "react-hook-form";
import ButtonElement from "../../../common/ButtonElement";
import DisplayError from "../../../common/DisplayError";
import HtmlElement from "../../../common/HtmlElement";
import { AppContext } from "../../../core/ApplicationContextProvider";
import DynamicForm from "../../../dynamic-form";
import "./MultiScreenViewer.css";
import type { AppContextType } from "../../../core/types";
import type { Loader } from "../../../../hooks/Loader";


// MultiScreenViewer props
export interface MultiScreenViewerProps {
  onSubmit: (data: Record<string, any>) => void;
  loader: Loader;
}

const errorText = "Te rugăm să verifici datele introduse.";

export const MultiScreenViewer: React.FC<MultiScreenViewerProps> = (props) => {
  const { details, currentScreen } = React.useContext(AppContext) as AppContextType;
  const defaults = currentScreen?.fields
    .filter((f) => !!f.value && !f.uiOnly)
    .reduce((acc, f) => {
      acc[f.name] = f.value;
      return acc;
    }, {} as Record<string, any>) || {};
  const form = useForm({ defaultValues: defaults });
  const { handleSubmit } = form;
  const loader = props.loader;

  if (!details?.campaignDetails || !currentScreen) return <></>;

  const onInvalid = (errors: any) => console.error(errors);

  return (
    <>
      <div className="text-center">
        <h3 className="text-orange">{currentScreen.title}</h3>
        <HtmlElement
          className="mb-4 medium-text subtitle"
          elements={currentScreen.subtitle}
        />
      </div>
      <FormProvider {...form}>
        <form onSubmit={handleSubmit(props.onSubmit, onInvalid)}>
          <DynamicForm fields={currentScreen.fields} useFormOptions={form} />
          <div className="text-center mb-3">
            <ButtonElement
              type="submit"
              fullWidthSm={true}
              disabled={loader.loading}
              buttonText={currentScreen.actionButtonLabel}
            />
            <DisplayError
              errorCondition={loader.error}
              errorMessage={errorText}
            />
          </div>
        </form>
      </FormProvider>
    </>
  );
};
